import OrigenDeudaCreate from './OrigenDeudaCreate'
export {OrigenDeudaCreate}
export default OrigenDeudaCreate
